"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "campobasso": {
    "c9d1cee1": [{
      "hkey": "bf057f57",
      "slug": "colle-delle-api-san-giovanni-in-golfo",
      "name": "Colle delle Api-San Giovanni in Golfo",
      "primary": true,
      "skipSearch": false
    }],
    "colle-delle-alpi": [{
      "hkey": "bf057f57",
      "slug": "colle-delle-api-san-giovanni-in-golfo",
      "name": "Colle delle Api-San Giovanni in Golfo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "720be345": [{
      "hkey": "f92a1fb0",
      "slug": "san-giovanni",
      "name": "San Giovanni",
      "primary": true,
      "skipSearch": false
    }],
    "s-giovanni": [{
      "hkey": "f92a1fb0",
      "slug": "san-giovanni",
      "name": "San Giovanni",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;